import PropTypes from 'prop-types';
import _, { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import hardDriveFilled from '@iconify/icons-eva/hard-drive-fill';
import fileTextFill from '@iconify/icons-eva/file-text-fill';
import safetyCertificate from '@iconify/icons-ant-design/safety-certificate';
import emailFilled from '@iconify/icons-eva/email-fill';
import { Link as RouterLink, useNavigate, useSearchParams } from 'react-router-dom';
import globeOutline from '@iconify/icons-eva/globe-outline';
import shuffleFill from '@iconify/icons-eva/shuffle-fill';
import questionFill from '@iconify/icons-eva/question-mark-circle-fill';
import tvFill from '@iconify/icons-eva/tv-fill';
// material
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Box,
  useMediaQuery,
  Tooltip,
  Pagination,
  Autocomplete,
  TextField
} from '@mui/material';
//
import { toast } from 'react-hot-toast';
import { useTheme } from '@mui/material/styles';
//
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import moment from 'moment-timezone';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
//
import ServicesListToolbar from '../components/_dashboard/services/ServicesListToolbar';
import ServicesListHead from '../components/_dashboard/services/ServicesListHead';
import ServicesMoreMenu from '../components/_dashboard/services/ServicesMoreMenu';
//
import * as myLayananService from '../services/mylayanan';
import * as instansiService from '../services/instansi';
import isEligible from '../utils/roleEligibleGetter';
import useWidth from '../hooks/useWidth';
import DialogConfirmation from '../components/DialogConfirmation';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'type', label: 'Tipe', alignRight: false },
  { id: 'keterangan', label: 'Keterangan', alignRight: false },
  { id: 'requestor', label: 'Requestor', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'createdAt', label: 'Created at', alignRight: false },
  { id: '' }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (data) =>
        data.meta?.keterangan.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        data.meta?.requestor.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        data.type?.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

ServicesPage.propTypes = {
  user: PropTypes.object
};

export default function ServicesPage({ user }) {
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [layanans, setLayanans] = useState([]);
  const [toggleRefresh, setToggleRefresh] = useState(true);
  const [totalData, setTotalData] = useState(0);
  const [instansis, setInstansis] = useState([]);
  const [selectedInstansi, setSelectedInstansi] = useState('');
  const [dialogConfirmationState, setDialogConfirmationState] = useState({
    open: false,
    closeButtonText: 'TUTUP',
    agreeButtonText: 'LENGKAPI SEKARANG',
    content: 'Status permohonan Anda masih DRAFT, harap segera melengkapi data permohonan.',
    title: 'Informasi'
  });

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const pageParam = parseInt(searchParams.get('page'), 10);
  const sizeParam = parseInt(searchParams.get('size'), 10);
  const queryParam = searchParams.get('search') || '';
  const typeParam = searchParams.get('type') || '';
  const resetParam = searchParams.get('reset') || '';
  const alertParam = searchParams.get('alert') || '';
  const createdIDParam = searchParams.get('createdID') || '';
  const instansiParam = searchParams.get('instansi_id') || '';

  const [page, setPage] = useState(pageParam - 1);

  const width = useWidth(useTheme, useMediaQuery);

  useEffect(() => {
    if (pageParam) setPage(pageParam - 1);
  }, [pageParam]);

  useEffect(() => {
    if (sizeParam) setRowsPerPage(sizeParam);
  }, [sizeParam]);

  useEffect(() => {
    if (queryParam) {
      setFilterName(queryParam);
      setToggleRefresh(!toggleRefresh);
    }
  }, [queryParam]);

  useEffect(() => {
    if (resetParam === '1') setToggleRefresh(!toggleRefresh);
  }, [resetParam]);

  useEffect(() => {
    setToggleRefresh(!toggleRefresh);
  }, [instansiParam]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = layanans.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleReset = () => {
    setFilterName('');
    navigate(`/dashboard/services?page=${1}&size=${rowsPerPage}&reset=1`, {
      replace: true
    });
  };

  const handleChangePage = (event, newPage, id) => {
    navigate(
      // `/dashboard/services?page=${
      //   newPage + 1
      // }&size=${rowsPerPage}&search=${queryParam}&instansi_id=${id}`,
      `/dashboard/services?page=${
        newPage + 1
      }&size=${rowsPerPage}&type=${typeParam}&search=${queryParam}&instansi_id=${id}`,
      {
        replace: true
      }
    );
  };

  const handleChangeInstansi = (event, id) => {
    navigate(
      `/dashboard/services?page=${pageParam}&size=${sizeParam}&search=${queryParam}&instansi_id=${id}`,
      {
        replace: true
      }
    );
  };

  const handleChangeRowsPerPage = (event) => {
    navigate(
      // `/dashboard/services?page=${1}&size=${parseInt(event.target.value, 10)}&search=${queryParam}`,
      `/dashboard/services?page=1&size=${parseInt(
        event.target.value,
        10
      )}&type=${typeParam}&search=${queryParam}`,
      { replace: true }
    );
  };

  const handleFilterByName = (event) => {
    const search = event?.target?.value;
    setFilterName(search);
  };

  const filteredDatas = applySortFilter(layanans, getComparator(order, orderBy));

  const dataNotFound = filteredDatas.length === 0;

  // ------------- GET INSTANSIS
  const getInstansis = async () => {
    try {
      const result = await instansiService.getAll();
      const { data } = result;

      const newInstansis = [];
      data.forEach((item) => {
        newInstansis.push({ id: item.id_instansi, label: item?.name });
      });
      setInstansis(newInstansis);
    } catch (error) {
      toast.error(error.message);
    }
  };

  // ------------- GET LAYANANS

  const getLayanans = async () => {
    try {
      const idInstansi = user?.attributes?.id_instansi;
      const role = user?.attributes?.role;
      const userID = user?.attributes?.id;
      if (!idInstansi && !role) return;

      const body = {
        id_instansi: isEligible('pilih_instansi') ? instansiParam : idInstansi,
        user_id: userID,
        role,
        page,
        size: rowsPerPage,
        search: queryParam
      };

      if (typeParam) body.type = typeParam;

      const result = await myLayananService.getlayanans(body);
      const lists = [];
      result.data.forEach((item) => {
        const { keterangan, requestor, status } = item.meta;
        const createdAt = item?.meta?.data_permohonan?.createdAt;
        lists.push({ ...item, keterangan, requestor, status, createdAt });
      });
      setLayanans(lists);
      setTotalData(result?.meta?.count);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const openDialogConfirmation = () => {
    setDialogConfirmationState({ ...dialogConfirmationState, open: true });
  };

  const closeDialogConfirmation = () => {
    setDialogConfirmationState({ ...dialogConfirmationState, open: false });
  };

  const agreeDialogConfirmation = () => {
    if (createdIDParam) {
      navigate(`/dashboard/services/${createdIDParam}`, { replace: true });
    } else {
      toast.error('Gagal mendapatkan ID permohonan');
      closeDialogConfirmation();
    }
  };

  useEffect(() => {
    if (alertParam === '1') openDialogConfirmation();
  }, [alertParam]);

  useEffect(() => {
    getLayanans();
  }, [toggleRefresh, user, page, rowsPerPage, instansis, instansiParam]);

  useEffect(() => {
    getInstansis();
  }, []);

  useEffect(() => {
    if (instansiParam) {
      const index = _.findIndex(instansis, (item) => item.id === instansiParam);
      if (index > -1) setSelectedInstansi(instansis[index]);
    } else {
      setSelectedInstansi('');
    }
  }, [instansis, instansiParam]);

  // ------------- DELETE LAYANAN

  const deleteLayanan = async (rowData) => {
    confirmAlert({
      title: 'Konfirmasi',
      message: 'Apakah Anda yakin akan menghapus data ini?',
      buttons: [
        {
          label: 'Yakin',
          onClick: async () => {
            try {
              const body = { id: rowData.id, meta: rowData.meta };
              const result = await myLayananService.deleteLayanan(body);
              toast.success('Data berhasil dihapus');
              setToggleRefresh(!toggleRefresh);
            } catch (error) {
              toast.error(error.message);
            }
          }
        },
        {
          label: 'Tidak',
          onClick: () => console.log('No')
        }
      ]
    });
  };

  const getIcon = (type) => {
    if (type === 'subdomain') return globeOutline;
    if (type === 'hosting') return hardDriveFilled;
    if (type === 'tte') return safetyCertificate;
    if (type === 'email') return emailFilled;
    if (type === 'rekomendasi') return fileTextFill;
    if (type === 'splp') return shuffleFill;
    if (type === 'aduan') return questionFill;
    if (type === 'videotron') return tvFill;
    return globeOutline;
  };

  const getStatusColor = (status) => {
    if (['rejected', 'archived', 'draft', 'suspended', 'expired', 'revision'].includes(status))
      return 'error';
    if (['submitted'].includes(status)) return 'warning';
    if (['approved'].includes(status)) return 'secondary';
    if (['activated', 'open'].includes(status)) return 'success';
    if (['pending', 'processed'].includes(status)) return 'warning';
  };

  const getStatusText = (status) => {
    let text = '';
    text = status;
    if (status === 'pending') text = 'processed';
    return sentenceCase(text);
  };

  const getKeterangan = (status) => {
    if (['rejected'].includes(status)) return 'Permohonan ditolak, harap membuat permohonan baru';
    if (['draft'].includes(status))
      return 'Harap melengkapi data formulir permohonan terlebih dahulu';
    if (['suspended'].includes(status))
      return 'Layanan ditangguhkan, membutuhkan tindak lanjut perbaikan';
    if (['submitted'].includes(status))
      return 'Permohonan berhasil dibuat, menunggu proses persetujuan';
    if (['approved'].includes(status)) return 'Permohonan telah disetujui';
    if (['activated'].includes(status)) return 'Permohonan telah diaktivasi';
    if (['pending', 'processed'].includes(status)) return 'Permohonan sedang di proses';
    if (['saved'].includes(status)) return 'Data permohonan disimpan';
    if (['revision'].includes(status)) return 'Data permohonan sedang direvisi';
    if (['close'].includes(status)) return 'Data permohonan telah diselesaikan';
    if (['open'].includes(status)) return 'Data permohonan sudah terkirim';
  };

  const getTipe = (type) => {
    if (type === 'subdomain') return 'Subdomain Hosting';
    if (type === 'tte') return 'TTE';
    if (type === 'splp') return 'SPLP';
    return sentenceCase(type);
  };

  const theme = useTheme();

  const handleSearch = () => {
    navigate(`/dashboard/services?page=${1}&size=${rowsPerPage}&search=${filterName}`, {
      replace: true
    });

    if (!filterName) setToggleRefresh(!toggleRefresh);
  };
  return (
    <Page title="Services | Peladen Pemda DIY">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Tracking Layanan
          </Typography>

          {isEligible('tambah_layanan') && (
            <Button
              variant="contained"
              component={RouterLink}
              to="/dashboard/requests"
              startIcon={<Icon icon={plusFill} />}
            >
              Tambah Layanan
            </Button>
          )}
        </Stack>

        <Card>
          <Stack
            direction="row"
            spacing={1}
            justifyContent="space-between"
            alignItems="center"
            mr={2}
          >
            <ServicesListToolbar
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
              onSearch={handleSearch}
              onReset={handleReset}
            />
            {isEligible('pilih_instansi') && (
              <Stack direction="row" spacing={1}>
                <Autocomplete
                  sx={{ width: 320 }}
                  disablePortal
                  id="combo-box-instansi"
                  options={instansis}
                  value={selectedInstansi}
                  onChange={(event, newValue) => {
                    if (newValue?.id) return handleChangeInstansi(event, newValue?.id);
                    handleChangeInstansi('', '');
                  }}
                  renderInput={(params) => (
                    <TextField size="small" {...params} label="Pilih Instansi" />
                  )}
                />
                <Button variant="outlined" onClick={() => handleChangeInstansi('', '')}>
                  Reset
                </Button>
              </Stack>
            )}
          </Stack>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ServicesListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={layanans.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredDatas
                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      const { type, id, meta, keterangan, requestor, status, createdAt } = row;
                      const isItemSelected = selected.indexOf(type) !== -1;

                      const cellStyle = { cursor: 'pointer' };
                      const cellOnClick = () => navigate(`/dashboard/services/${id}`);

                      return (
                        <TableRow
                          hover
                          key={id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell />
                          <TableCell
                            component="th"
                            scope="row"
                            padding="none"
                            style={{ ...cellStyle }}
                            onClick={cellOnClick}
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Icon
                                icon={getIcon(type)}
                                width={24}
                                height={24}
                                color={theme.palette.primary.main}
                              />
                              <Typography variant="subtitle2" noWrap>
                                {getTipe(type)}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell style={{ ...cellStyle }} onClick={cellOnClick} align="left">
                            {keterangan}
                          </TableCell>
                          <TableCell style={{ ...cellStyle }} onClick={cellOnClick} align="left">
                            <Typography variant="body2" noWrap style={{ maxWidth: '10rem' }}>
                              {requestor}
                            </Typography>
                          </TableCell>
                          <Tooltip
                            style={{ ...cellStyle }}
                            onClick={cellOnClick}
                            title={getKeterangan(status)}
                            arrow
                          >
                            <TableCell align="left">
                              <Label variant="ghost" color={getStatusColor(status)}>
                                {getStatusText(status)}
                              </Label>
                            </TableCell>
                          </Tooltip>
                          <TableCell style={{ ...cellStyle }} onClick={cellOnClick} align="left">
                            {moment.tz(createdAt, 'Asia/Jakarta').format('YYYY-MM-DD')}
                          </TableCell>

                          <TableCell align="right">
                            <ServicesMoreMenu
                              onDelete={deleteLayanan}
                              rowData={{ id, type, meta, status }}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )} */}
                </TableBody>
                <>
                  {dataNotFound && (
                    <>
                      {dataNotFound && filterName ? (
                        <TableBody>
                          <TableRow>
                            <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                              <SearchNotFound searchQuery={filterName} />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : (
                        <TableBody>
                          <TableRow>
                            <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                              <Typography variant="body2">Belum ada data yang ditemukan</Typography>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      )}
                    </>
                  )}
                </>
              </Table>
            </TableContainer>
          </Scrollbar>

          <Stack
            direction={['xs', 'sm'].includes(width) ? 'column' : 'row'}
            spacing={1}
            alignItems="center"
            justifyContent="center"
            m={2}
          >
            <Pagination
              // onChange={(e, page) => handleChangePage(e, page - 1, selectedInstansi?.id)}
              onChange={(e, page) => {
                if (!selectedInstansi?.id) {
                  handleChangePage(e, page - 1, '');
                  console.log('instansi', selectedInstansi?.id);
                } else {
                  handleChangePage(e, page - 1, selectedInstansi?.id);
                  console.log('instansi', selectedInstansi?.id);
                }
              }}
              count={Math.ceil(totalData / rowsPerPage)}
              shape="rounded"
              page={page + 1}
              showFirstButton="true"
              showLastButton="true"
            />
            <TablePagination
              rowsPerPageOptions={[10, 30, 50]}
              component="div"
              count={totalData}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Stack>
        </Card>
        <Stack direction="column" pt={4} spacing={1}>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            Keterangan
          </Typography>
          <Box>
            <Stack direction="column" pb={4} spacing={1}>
              {[
                'open',
                'activated',
                'approved',
                'submitted',
                'processed',
                'saved',
                'close',
                'revision',
                'suspended',
                'draft',
                'rejected'
              ].map((status) => (
                <Stack direction="row" spacing={1} alignItems="center">
                  <Label
                    variant="ghost"
                    color={getStatusColor(status)}
                    sx={{ flex: ['xs', 'sm'].includes(width) ? 2 : 1 }}
                  >
                    {sentenceCase(status || 'undefined')}
                  </Label>
                  <Typography sx={{ flex: 6 }} variant="body2">
                    {getKeterangan(status)}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Box>
        </Stack>
        <DialogConfirmation
          open={dialogConfirmationState.open}
          handleClose={closeDialogConfirmation}
          handleAgree={agreeDialogConfirmation}
          title={dialogConfirmationState.title}
          content={dialogConfirmationState.content}
          closeButtonText=""
          agreeButtonText={dialogConfirmationState.agreeButtonText}
        />
      </Container>
    </Page>
  );
}
